import { embeddedAppDefaultPages } from '@/embedded-apps/embeddedAppManifest'
import { resolveAppLaunchKind } from '@/util/appTypes'

const EMBEDDED_PAGE_FALLBACK = 'home'

function normalizeEmbeddedPageSegment(page: string): string {
  return page.replace(/^\/+/, '')
}

export function getAppLaunchPath(
  appTypes: number,
  appKey: string,
  appId: number,
  projectId: number,
  workspaceId: number,
  organisationId: number,
  returnPage?: string
) {
  const searchParamString = `appId=${appId}&projectId=${projectId}&workspaceId=${workspaceId}&organisationId=${organisationId}`
  const launchKind = resolveAppLaunchKind(appTypes)

  if (launchKind === 'embedded') {
    const defaultPage = normalizeEmbeddedPageSegment(
      embeddedAppDefaultPages[appKey] ?? EMBEDDED_PAGE_FALLBACK
    )
    return returnPage
      ? `/embedded${returnPage}?${searchParamString}`
      : `/embedded/${appKey}/${defaultPage}?${searchParamString}`
  }

  if (launchKind === 'catalog') {
    return returnPage
      ? `/apps${returnPage}?${searchParamString}`
      : `/apps/${appKey}/home?${searchParamString}`
  }

  return `/${appKey}/home?pid=${projectId}`
}
